import {
  SVButton,
  SVListFilters,
  SVListPagination,
  SVLoader,
} from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { FILTERS } from '@/constants/filters';
import { useGetBankApplicationsList } from '@/hooks/requests/useBankApplications';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { Card, Stack, Typography } from '@mui/material';
import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';
import BankApplicationsList from '@/components/bankAccountApplications/BankApplicationsList';
import { BankApplicationStatus } from '@/types/bankApplications';

export default function BankApplicationsDraftPage() {
  const navigate = useNavigate();
  const {
    bankApplications,
    isBankApplicationsPending,
    isSuccess,
    totalRecordCount,
  } = useGetBankApplicationsList([BankApplicationStatus.DRAFT]);
  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.ACCOUNT_TYPE],
    hasCompanyFilter: true,
    hasTeammateFilter: true,
    hasCustomerFilter: true,
  });
  const header = `Bank Account Applications - Draft ${totalRecordCount ? `(${totalRecordCount})` : ''}`;

  if (isBankApplicationsPending) {
    return (
      <DefaultLayout header={header}>
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={header}
      buttons={[
        <SVButton
          key="add"
          onClick={() => navigate(ROUTES.BANK_ACCOUNT_APPLICATIONS)}
          fullWidth
          aria-label="Add Bank Account Application">
          Add
        </SVButton>,
      ]}>
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by owner email or application ID"
      />
      {isBankApplicationsPending ? (
        <SVLoader />
      ) : (
        <>
          {bankApplications.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              <BankApplicationsList bankApplications={bankApplications} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
